export default {
  methods: {
    isReportEditable(locked) {
      if (!locked || this.$can('doAccounting') || this.$can('superAdministrate')) {
        return true;
      } else {
        return false;
      }
    },
    isJobEditable(job) {
      return job.id === null ? true : job.job_status_id !== 4 ? true : this.$can('doAccounting') || this.$can('superAdministrate');
    },
    getFileNameFromContentDisposition(contentDisposition) {
      const matches = contentDisposition.match(/filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/i);
      return Buffer.from( matches[3] !== undefined ? decodeURIComponent(matches[3]) : matches[2] !== undefined ? decodeURIComponent(matches[2]) : '', 'binary').toString('utf8');
    },
  },
};
